import { FeaturesQuery } from '@/graphql/graphql';
import * as THREE from 'three';

export const computeMapOrigin = (features: FeaturesQuery['featuresByLayer'][number][]): THREE.Vector3 => {
  let minX = Infinity,
    minY = Infinity,
    minZ = Infinity;
  let maxX = -Infinity,
    maxY = -Infinity,
    maxZ = -Infinity;

  const scan = (c: any): void => {
    if (c == null || c[0] === undefined) return;
    return Array.isArray(c[0])
      ? c.forEach(scan)
      : ((minX = Math.min(minX, c[0])),
        (maxX = Math.max(maxX, c[0])),
        (minY = Math.min(minY, c[1])),
        (maxY = Math.max(maxY, c[1])),
        (minZ = Math.min(minZ, c[2] || 0)),
        (maxZ = Math.max(maxZ, c[2] || 0)));
  };

  // A geometry is either coordinate-bearing (Point/…/MultiPolygon) or a
  // GeometryCollection nesting more geometries — which, per the GeoJSON spec
  // and `GeoJson.tsx`'s own recursive `FeatureElement`, can itself be another
  // GeometryCollection. Walking only one level of `.geometries` left a nested
  // collection's `.coordinates` undefined, so `scan(g.coordinates)` crashed
  // with "Cannot read properties of undefined (reading '0')". A null
  // `feature.geometry` (valid GeoJSON for a feature with no geometry) is
  // handled the same way, by the `!g` guard.
  const scanGeometry = (g: any): void => {
    if (!g) return;
    if (g.coordinates) scan(g.coordinates);
    else if (g.geometries) g.geometries.forEach(scanGeometry);
  };

  features.forEach((f) => scanGeometry(f.geometry));
  return new THREE.Vector3((minX + maxX) / 2, (minY + maxY) / 2, (minZ + maxZ) / 2);
};
